import generateEntitySagas from './generate-entity-sagas';

export default generateEntitySagas;
